import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { Image as CloudinaryImage, Transformation } from "cloudinary-react";
import Image from "../Image/Image.jsx";
import { UncontrolledPopover, PopoverHeader, PopoverBody } from "reactstrap";
import { uploadVideo } from "../../utils/videoUpload";
import { uploadFile } from "../../utils/fileUpload";

class ReportModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  componentWillMount() {}

  saveClick = async file => {
    let { data } = this.props;
    this.props.modalClose();
    this.props.showLoader();
    let imageID = await uploadFile(file);
    this.props.updateProfileMedia({
      contestName: data.contestName,
      profilePic: imageID.public_id
    });
  };

  updateProfilePic = async e => {
    let { data } = this.props;
    if (e.target.files.length) {
      let file = e.target.files[0];
      const reader = new FileReader();
      reader.addEventListener("load", test => {
        this.props.imageCropModalOpen({
          file: file,
          src: reader.result,
          fileName: file.name,
          mimeType: file.type,
          redirect: "user-profile",
          saveClick: this.saveClick
        });
        this.setState({ src: reader.result });
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  updateIntroVideo = async e => {
    let { data } = this.props;
    if (e.target.files.length && e.target.files[0].type.includes("video")) {
      this.props.modalClose();
      this.props.showLoader("Please wait we are uploading your video...");
      await uploadVideo(e.target.files[0], (err, data1) => {
        if (!err) {
          this.props.updateProfileMedia({
            contestName: data.contestName,
            introductionVideo: [data1.Location]
          });
        }
      });
    }
  };
  render() {
    let { data } = this.props;

    return (
      <div
        className="modal"
        id="ticketmodal"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
        style={this.props.open ? { display: "block" } : {}}
        onClick={this.props.modalClose}
      >
        <div
          className="modal-dialog modal-sm modal-dialog-centered"
          role="document"
        >
          <div
            className="modal-content animated bounceIn"
            onClick={e => e.stopPropagation()}
          >
            <div className="ticket-modal">
              <React.Fragment>
                <div className="reportcontent">
                  <p className="mb-0 cotmed">Profile media</p>
                </div>
                <div className="modalmaincontent reportmaincontent pt-0">
                  <a
                    onClick={e => {
                      e.stopPropagation();
                      this.props.showContestProfileViewProfilePic();
                      this.props.modalClose();
                    }}
                  >
                    See profile pic
                  </a>
                  {data.introVideoStatus ? (
                    <a
                      onClick={e => {
                        e.stopPropagation();
                        this.props.showContestProfileViewIntroVideo();
                        this.props.modalClose();
                      }}
                    >
                      Watch intro video
                    </a>
                  ) : null}

                  {data.myProfile ? (
                    <a
                      onClick={e => {
                        e.stopPropagation();
                      }}
                      style={{ position: "relative" }}
                    >
                      <span>Update profile pic</span>
                      <input
                        id="profilePic"
                        className="fileMediaUpload"
                        type="file"
                        accept="image/*"
                        onChange={this.updateProfilePic}
                      />
                    </a>
                  ) : null}

                  {data.myProfile ? (
                    <a
                      onClick={e => {
                        e.stopPropagation();
                      }}
                      style={{ position: "relative" }}
                    >
                      <span>
                        {data.introVideoStatus
                          ? "Update intro video"
                          : "Upload intro video"}
                      </span>
                      <input
                        id="profilePic"
                        className="fileMediaUpload"
                        type="file"
                        accept="video/*"
                        onChange={this.updateIntroVideo}
                      />
                    </a>
                  ) : null}
                </div>
              </React.Fragment>
              <div
                className="modalfooter pointer"
                onClick={this.props.modalClose}
              >
                <a className="">Cancel</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ profileMediaModal }) => {
  const { open, data } = profileMediaModal;
  return { open, data };
};

const mapDispatchToProps = dispatch => ({
  modalClose: () => dispatch(actions.profileMediaModalClose()),
  showLoader: payload => dispatch(actions.showUploadMediaLoader(payload)),
  showContestProfileViewProfilePic: () =>
    dispatch(actions.showContestProfileViewProfilePic()),
  showContestProfileViewIntroVideo: () =>
    dispatch(actions.showContestProfileViewIntroVideo()),
  hideContestProfileViewProfilePic: () =>
    dispatch(actions.hideContestProfileViewProfilePic()),
  hideContestProfileViewIntroVideo: () =>
    dispatch(actions.hideContestProfileViewIntroVideo()),
  updateProfileMedia: payload => dispatch(actions.updateProfileMedia(payload)),
  imageCropModalOpen: payload => dispatch(actions.imageCropModalOpen(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportModal);
